export default __webpack_public_path__ + "static/electrician-bee-b20f7cf130a2ff0128c3a74bfeda1cb2.png";